export default "__VITE_ASSET__B4SS77Xb__"